module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/required_icon-b5e8c8f9d5f3dcef3256fef09c7af0c4.png";